export default __webpack_public_path__ + "static/media/astro.fed9931e.jpg";